import { Box, Chip, Divider, Stack, Typography } from "@mui/material";

import { RoutePointLocationDisplay } from "./RoutePointLocationDisplay";
import { ISOStringToReadableDate } from "../../../utils";

interface Props {
  routePoint: RoutePoint;
  displayRoutePointDates: boolean;
  /**
   * Replaces the location line. The default branches on the viewer's role, and
   * its carrier branch needs the in-app carrier shipment context — so a surface
   * mounted outside that provider renders a stop with no address at all unless
   * it passes its own. The unauthenticated command-link landing is one.
   */
  locationDisplay?: React.ReactNode;
}

export function RoutePointDetail(props: Props) {
  const { routePoint, displayRoutePointDates, locationDisplay } = props;

  const getPointTimestamps = () => {
    const dateLabel =
      routePoint.stop_operation === "DROPOFF" ? "Drop off by" : "Ready";
    return (
      <Stack direction="column" spacing={1} mr="1rem">
        <Stack direction="row" justifyContent="right">
          <Typography sx={{ fontSize: "0.7rem", color: "#b9b9b9" }}>
            {dateLabel}
          </Typography>
        </Stack>
        <Stack direction="row" justifyContent="right">
          <Typography>
            {routePoint.schedule_type === "DATETIME"
              ? ISOStringToReadableDate(routePoint.start_time)
              : "Flexible"}
          </Typography>
        </Stack>
      </Stack>
    );
  };

  return (
    <div>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p=".5rem"
      >
        <Stack direction="row">
          <Chip
            variant="outlined"
            sx={{ minWidth: "50px", mr: "1rem" }}
            color="primary"
            label={
              routePoint?.point_number ? `${routePoint?.point_number}` : "-"
            }
          />
          <Chip
            sx={{ minWidth: "50px", mr: "1rem" }}
            variant="outlined"
            label={routePoint?.stop_operation ?? "-"}
          />
          {locationDisplay ?? (
            <RoutePointLocationDisplay routePoint={routePoint} />
          )}
        </Stack>
        <Stack
          direction="row"
          alignItems="baseline"
          justifyContent="space-between"
        >
          {displayRoutePointDates && <Box>{getPointTimestamps()}</Box>}
        </Stack>
      </Stack>
      <Divider />
    </div>
  );
}
